import { Button } from "@omni/ui/components/Button/button.component";
import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import { useSidebarContext } from "@/components/Navigation/Sidebar/context/sidebar.context";
import { useDepth } from "@/context/depth.context";
import { FlyoutCategory } from "@/redux/modules/value/flyoutCategories/flyoutCategories.types";
import { getTagIdFor } from "@/utils/tagging/tag.utils";

type Props = {
    category: FlyoutCategory;
    className?: string;
};

export const CategoryButton = ({ category, className }: Props) => {
    const { contentElementRef, setActiveCatetoryIndexes } = useSidebarContext();
    const { depth } = useDepth();
    const { index } = useMapped();

    const handleOnClick = () => {
        contentElementRef?.current?.scrollTo({ top: 0 });

        setActiveCatetoryIndexes((prev) => [...prev.slice(0, depth), index]);
    };

    return (
        <Button
            color={"link"}
            fullWidth={true}
            onClick={handleOnClick}
            className={cn(
                "tw:px-4 tw:py-2 tw:border-b tw:border-grey-light tw:flex tw:justify-between tw:items-center tw:group tw:transition-colors tw:rounded-none! tw:no-underline!",
                className
            )}
            {...getTagIdFor("flyout-menu-mobile-category-link", category.code)}
        >
            <span className={cn("tw:group-hover:underline")}>
                {category.title}
            </span>
            <i className={cn("las la-angle-right", "tw:text-primary")} />
        </Button>
    );
};
